import { render, staticRenderFns } from "./vulnerabilities_over_time_chart_buttons.vue?vue&type=template&id=6f356a89&"
import script from "./vulnerabilities_over_time_chart_buttons.vue?vue&type=script&lang=js&"
export * from "./vulnerabilities_over_time_chart_buttons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports